import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import excel from '~/skills/excel';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';

const RenderTableTitle = () => {
  const ary = [
    {
      name: '製造',
      detail: [
        { name: '期間' },
        { name: '累計' },
      ],
    },
    {
      name: '運輸',
      detail: [
        { name: '期間' },
        { name: '累計' },
      ],
    },
    {
      name: '安裝',
      detail: [
        { name: '期間' },
        { name: '累計' },
      ],
    },
  ];
  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        <T_TitleCell rowSpan={2} style={{ fontSize: 20 }} color='#247691' text='項目' />
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            style={{
              border: 'solid #DDDDDD',
              borderWidth: `0px ${(i !== (ary.length - 1)) ? 1 : 0}px 1px 1px`,
            }}
            text={o.name}
            colSpan={o.detail.length || 1}
          />
        ))}
      </TableRow>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => o.detail.map((o2, i2) => (
          <T_TitleCell
            key={`${i}-${i2}`}
            style={{
              border: 'solid #DDDDDD',
              borderWidth: `0px ${((i2 === (o.detail.length - 1)) && (i !== (ary.length - 1))) ? 1 : 0}px 1px ${(i2 === 0) ? 1 : 0}px`,
            }}
            text={o2.name}
            color='#247691'
          />
        )))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = ({ list = [] }) => {
  // const list = useSelector(state => state.data.BIPItem || []);
  const getRowSpanValue = (index, spanArry) => {
    const foundObj = spanArry.find((obj) => obj.index === index);
    return foundObj ? foundObj.span : undefined;
  };

  const renderRow = (item, index, mIndex = 0) => {
    const { project, dataAry, rowSpan } = item;
    const key = `${index}-${mIndex}`;
    return (
      <T_TableRow key={key} backgroundColor={(index % 2 === 0) ? '#F1F1F1' : 'transparent'}>
        <TableCell align='center' style={{ color: '#247691', ...cellStyle }}>{project}</TableCell>
        {dataAry.map((column, cIdx) => (
            <TableCell
                key={`${key}-${cIdx}`}
                align='center'
                style={cellStyle}
                rowSpan={rowSpan ? getRowSpanValue(cIdx, rowSpan) : undefined}
            >
                {column}
            </TableCell>
        ))}
      </T_TableRow>
    );
  };
  const cellStyle = { fontSize: 14 };

  return (
    <TableBody>
      {list.map((item, index) => (
          <React.Fragment key={index}>
          {item?.multiple
              ? item.data.map((mItem, mIndex) => renderRow(mItem, index, mIndex))
              : renderRow(item, index)}
          </React.Fragment>
      ))}
    </TableBody>
  );
};

const RenderTable = ({ list = [] }) => {
  // const list = useSelector(state => state.data.BIPItem || []);
  const haveData = list.length > 0;
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        {haveData && <RenderTableBody list={list} />}
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const { data = {}, searchTime } = props;
  const { list = [], wind_name = '-' } = data;
  // const list = useSelector(state => state.data.BIPItem || []);
  const { startDate, endDate, timeUnit } = searchTime;
  const TUnit = (timeUnit == 'week')? 'Week (週)' : 'Month (月)';
  const TimePeriod = `(${startDate} ~ ${endDate}) ${TUnit}`;

  const haveData = list.length > 0;
  const onExport = () => {
    if ((list.length || 0) === 0) {
      alert('無匯出資料');
    } else {
      const excelAry = [
        ['項目', '製造', '', '運輸', '', '安裝', ''],
        ['', TimePeriod, '累計', TimePeriod, '累計', TimePeriod, '累計'],
      ];
      list.forEach(o => {
        if (!o.multiple) {
          excelAry.push([o.project || '', ...o.dataAry]);
        } else {
          const toAdds = [];
          o.data[0].rowSpan.forEach(span => {
            toAdds.push(span.index);
          });

          o.data.forEach((item, idx) => {
            const rowData = [item.project || '', ...item.dataAry];
            if (idx > 0) {
              toAdds.forEach(index => {
                // 因為 project name, 讓原本 index+1
                rowData.splice((index+1), 0, '');
              });
            }
            excelAry.push(rowData);
          });
        }
      });

      excel.outputAryAry({
        data: excelAry,
        fileName: `累計報表_${wind_name}`,
      });
    }
  };

  return [
    <div key='1' style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
      <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
    </div>,
    <SearchBar key='2' style={{ marginTop: 16, marginBottom: 16 }} text={`${wind_name} ${TimePeriod}`}>
      <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
        <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
          <RenderTable list={list} />
          {/* {haveData && this.renderTableBar()} */}
        </div>
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
      </div>
    </SearchBar>,
  ];
};

export default App;
